import { render, staticRenderFns } from "./FixProblems.vue?vue&type=template&id=17e747b9&"
import script from "./FixProblems.vue?vue&type=script&lang=js&"
export * from "./FixProblems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports